'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBorderHorizontal = function MdBorderHorizontal(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 35v-3.4h3.4v3.4h-3.4z m-6.6 0v-3.4h3.4v3.4h-3.4z m-6.6-6.6v-3.4h3.2v3.4h-3.2z m13.2-13.4v-3.4h3.4v3.4h-3.4z m0-10h3.4v3.4h-3.4v-3.4z m-26.6 16.6v-3.2h30v3.2h-30z m13.4 13.4v-3.4h3.2v3.4h-3.2z m13.2-6.6v-3.4h3.4v3.4h-3.4z m-10-23.4v3.4h-3.2v-3.4h3.2z m0 6.6v3.4h-3.2v-3.4h3.2z m6.8-6.6v3.4h-3.4v-3.4h3.4z m-13.4 0v3.4h-3.4v-3.4h3.4z m-6.6 0v3.4h-3.4v-3.4h3.4z m3.2 30v-3.4h3.4v3.4h-3.4z m-6.6-6.6v-3.4h3.4v3.4h-3.4z m3.4-16.8v3.4h-3.4v-3.4h3.4z m-3.4 23.4v-3.4h3.4v3.4h-3.4z' })
        )
    );
};

exports.default = MdBorderHorizontal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/border-horizontal.js
// module id = 788
// module chunks = 36573943044255 79611799117203 213534597649335